import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { login } from "../../services/auth.api";
import { AUTH_STATUS } from "../../utils/authUtils";
import useAuth from "../../context/AuthContext";

import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const { status } = useAuth();

  useEffect(() => {
    const { LOADING, UNAUTHENTICATED, AUTHENTICATED } = AUTH_STATUS;

    if (status !== LOADING && status === UNAUTHENTICATED) {
      login();
    } else if (status === AUTHENTICATED) {
      navigate("/home");
    }
  }, [navigate, status]);

  return (
    <div>
      <div className="center">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Login;
